import { useEffect, useState } from "react";

/** Cycles through `messages` with random non-repeating picks while `active` is true. */
export function useRotatingWaitMessage(
  active: boolean,
  messages: readonly string[],
  intervalMs = 2500
): string {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (!active) {
      setIdx(0);
      return;
    }
    if (messages.length > 0) {
      setIdx(Math.floor(Math.random() * messages.length));
    }
    const interval = setInterval(() => {
      setIdx((prev) => {
        let next: number;
        do {
          next = Math.floor(Math.random() * messages.length);
        } while (next === prev && messages.length > 1);
        return next;
      });
    }, intervalMs);
    return () => clearInterval(interval);
  }, [active, messages, intervalMs]);

  return messages[idx] ?? messages[0] ?? "";
}
